<div *ngIf="redAlert" class="red-alert">
	ESTE NÃO É UM AMBIENTE DE PRODUÇÃO
</div>
<main>
	<div class="router">
		<router-outlet></router-outlet>
	</div>
</main>